import { ArrowLeft } from '@phosphor-icons/react'
import { useId } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { kuniriIconWeight } from '@/lib/icons'

/**
 * Universal back affordance for the settings IA (D-099): one `←` icon in the
 * top-left corner of every settings page, one level up. There is no extra
 * "back to menu" text/button anywhere in the section.
 */
export function SettingsBackLink({
  to,
  labelKey = 'common.back',
}: {
  to: string
  labelKey?: string
}) {
  const { t } = useTranslation()
  const linkId = useId()
  return (
    <Link
      id={linkId}
      to={to}
      className="grid size-11 shrink-0 place-items-center rounded-full text-deep hover:bg-mint"
      aria-label={t(labelKey)}
    >
      <ArrowLeft size={22} weight={kuniriIconWeight} aria-hidden="true" />
    </Link>
  )
}
